import {FC, useCallback, useRef} from 'react';
import {Button, Message, Modal} from 'semantic-ui-react';
import {observer} from 'mobx-react';

import ActionButtons from './ActionButtons';
import {useTooltip} from '../../components/graphs/GraphTooltips';
import {useRackEditorStore} from '../hooks/useRackEditorStore';
import buttons from './buttons';

import './Actions.less';

type ActionsPropsType = {
  onClose: (...args: any[]) => any;
  isCloning?: boolean;
  httpMethod: string;
  httpUrl: string;
}

const Actions: FC<ActionsPropsType> = ({onClose, isCloning, httpMethod, httpUrl}) => {
  const {rackStore} = useRackEditorStore();
  const {id, isSaving, error} = rackStore;
  const {showActionTooltip, isValid} = useActions();
  const containerRef = useRef<HTMLDivElement>(null);

  const hideTooltip = showActionTooltip();

  return (
    <Modal.Actions onMouseOut={hideTooltip} onBlur={hideTooltip}>
      {error &&
        <Message
          error
          className='rt-global-error'
          content={error}
          onDismiss={() => rackStore.setError()}
        />}
      <div ref={containerRef} className='rt-actions'>
        <div className='extra-actions'>
          <ActionButtons buttons={buttons} containerRef={containerRef} />
        </div>
        <div>
          <Button
            size='large'
            primary
            content={isCloning ? 'Clone' : (id ? 'Update' : 'Create')}
            aria-label='Save changes'
            onClick={() => rackStore.submit(onClose, httpMethod, httpUrl)}
            disabled={!isValid || isSaving}
            loading={isSaving}
          />
        </div>
      </div>
    </Modal.Actions>
  );
};

const useActions = () => {
  const {rackStore} = useRackEditorStore();
  const {isValid} = rackStore;
  const {sharedTooltip} = useTooltip();

  // Show/hide action button tooltip
  const showActionTooltip = useCallback((title?: string) => (e: MouseEvent) => {
    if (title) {
      sharedTooltip.show(title);
    } else {
      sharedTooltip.hide();
    }
    e.stopPropagation();
  }, [sharedTooltip]);

  return {showActionTooltip, isValid};
};

export default observer(Actions);
